export default __webpack_public_path__ + "static/media/team78.aa0ce2db.JPG";